<template lang="pug">
  div.card-info
    el-row(align="middle", gutter="20").tb.d-flex
      el-col(:span="prolongado? 24 : 18").column
        p.verde-text.text-aviso {{textAviso}}
        p.verde-text.text-between {{textBetween}}
      el-col(:span="4", v-if="!prolongado").botao
        el-button.green.textButtonBreak(
          tipo="success",
          @click="prolongar"
        )
          span.center
            i.fal.fa-credit-card
            | &nbsp Prolongar prazo

</template>

<script>
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'

export default {

  data () {
    return {
      daesBoleto: null,
      protocolo: null,
      Notificacao: null,
      dadosNotificacao: null,
      processo: null,
      isVencido: true
    }
  },
  mixins: [
    AppNotificacao
  ],
  async mounted () {
  },
  methods: {
    ...mapActions({
      prolongarConversa: 'conversa/prolongarConversa'
    }),
    prolongar () {
      this.confirmBox(this.$messages.PROLOGAR_PRAZO_CONFIRM, this.$messages.TITULO_WARNING,
        () => {
          this.prolongarConversa(this.idConversa).then((res) => {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
              'Prazo prolongado com sucesso.')
            this.$emit('prolongado', res.data)
          },
          () => {
            this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
              'Erro ao prolongar prazo.')
          })
        },
        () => {
        })
    }
  },
  props: {
    conversasAbertas: {
      type: Array,
      required: true
    },
    prolongado: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dataLimite () {
      return this.conversasAbertas.map((x) => x).sort((a, b) => (a.dataInicioConversa > b.dataInicioConversa) ? 1 : ((b.dataInicioConversa > a.dataInicioConversa) ? -1 : 0))[0].mensagemList.slice(-1)[0].dataLimiteFormatada
    },
    idConversa () {
      return this.conversasAbertas.map((x) => x).sort((a, b) => (a.dataInicioConversa > b.dataInicioConversa) ? 1 : ((b.dataInicioConversa > a.dataInicioConversa) ? -1 : 0))[0].id
    },
    textAviso () {
      return !this.prolongado ? `O prazo de resposta da notificação é até dia ${this.dataLimite}!` : `Sua data limite de resposta foi atualizada para o dia ${this.dataLimite}.`
    },
    textBetween () {
      return !this.prolongado ? 'Caso necessite de prolongamento de prazo clique no botão ao lado. Se a notificação atingir a data limite, o processo será arquivado automaticamente.' : 'Se a notificação atingir a data limite, o processo será arquivado automaticamente.'
    }
  }
}
</script>

<style scoped lang="scss">
.card-info {
  border-radius: 15px;
  background-color: #fff;
  border: solid 1px #009d64;
  margin: 2%;
}

.d-flex {
  height: 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tb {
  margin-top: 10px;
  margin-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
}

.verde-text {
  color: #009d64 !important;
}

.green {
  color: #ffffff;
  background-color: #009f61;
  height: 40px;
}

.text-between {
 flex-direction: column;
}

.center {
  display: flex;
  align-items: center;
}

.botao{
  justify-content: flex-end;
}

@media (max-width: 780px) {
  .tb {
    margin-bottom: 275px;
    display: flex;
    flex-direction: column;
  }

  .green {
    position: relative;
    top: 45px;
    right: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/centralMensagens/AppAvisoNotificacao.vue